/*
==========================================
Custom JS for tab display
==========================================
*/

// タブ切り替え処理
const tabSwitch = (_this) => {
  const tabGroup = _this.dataset.tab_group;
  const ancestorEle = _this.closest(
    `.c-tab-block[data-tab_group="${tabGroup}"]`
  );
  ancestorEle
    .getElementsByClassName("is-active")[0]
    .classList.remove("is-active");
  _this.classList.add("is-active");
  ancestorEle.getElementsByClassName("is-show")[0].classList.remove("is-show");
  const groupTabs = ancestorEle.getElementsByClassName("c-tab");
  const arrayTabs = Array.prototype.slice.call(groupTabs);
  const index = arrayTabs.indexOf(_this);
  ancestorEle.getElementsByClassName("c-panel")[index].classList.add("is-show");
};
